import React from "react";
import useStyles from "./styles";
import { Box, Typography } from "@material-ui/core";
import ConfettiAnimation from "../../assets/gifs/confettis/confetti.gif";
import { CheckCircleOutline } from "@material-ui/icons";

const TargetApproval = ({ message }) => {
  const classes = useStyles();

  return (
    <Box className={classes.overlay}>
      <Box
        className={`${classes.content} confetti-wrapper`}
        display="flex"
        flexDirection="column"
        height="100%"
        width="100%"
        alignItems="center"
        justifyContent="center"
      >
        <img src={ConfettiAnimation} alt="confetti animation" />
        {message ? <Box display="flex" alignItems="center" className={classes.confettiMsg}>
          <CheckCircleOutline />
          <Typography variant="body2">
            {message}
          </Typography>
        </Box> : ""}
      </Box>
    </Box>
  );
};

export default TargetApproval;
